module.exports = __webpack_public_path__ + "img/sylvester-rugan.033fc156.png";